import { SET_STATS } from "../mutation-types";
import { userServiceStats } from "@/services/service";
import moment from "jalali-moment";

export default {
  [SET_STATS]: async (state, serviceId) => {
    state.loading = true;
    let cpu = [...state.cpuStats];
    let ram = [...state.ramStats];
    const [error, data] = await userServiceStats(serviceId);
    if (!error) {
      if (data.apiStatus === 200) {
        let time = moment(new Date()).format("HH:mm:ss");
        cpu.push({ time, data: data.apiData.cpu });
        ram.push({ time, data: data.apiData.ram });
        state.loading = false;
        state.cpuStats = [...cpu];
        state.ramStats = [...ram];
      } else {
        console.log(data.apiErrors);
        state.errorMessages = data.apiErrors;
        state.loading = false;
      }
    }
  }
};
